import React, { useMemo } from 'react'
import PDF_ICON from "../../../assets/images/pdf-icon.png"
import "./investor-pdf-card.css";
import {UAParser} from 'ua-parser-js'
import { get_google_doc_pdf_viewer_url } from '../../../utils';
import { createSearchURLParams } from '../../Helper';

export default function InvestorPDFCard({pdf_data}) {
  const ua = UAParser(window.navigator.userAgent)
  const os_name = (ua.os.name || "").toLowerCase()
  const is_android = os_name === "android"
  //createSearchURLParams('pdf-viewer', {mode: 'app', file: get_google_doc_pdf_viewer_url(pdf?.file_name)})
  return (
    <section className='investor-pdf-card-container'>
        {
            pdf_data?.map((pdf, index) => {
                const pdf_url = is_android ? get_google_doc_pdf_viewer_url(pdf?.file_name) : pdf?.file_name
                return (
                <a href={pdf_url} className='investor-pdf-card' target='_blank' rel="noopener noreferrer" key={`pdf_${pdf?.document_name}_${index}`}>
                    <div className='image-section'>
                        <img src={PDF_ICON} alt='pdf'/>
                    </div>
                    <div className='details-section'>
                        <p className='doc-name'>{pdf?.document_name}</p>
                    </div>
                </a>
                )

            })
        }
    </section>
  )
}
